const IdSituacaoTarefaEnum = {
  PENDENTE: 0,
  EM_ANDAMENTO: 10,
  AGUARDANDO: 20,
  CONCLUIDO: 90,
  CANCELADO: 99
}

export default IdSituacaoTarefaEnum



// WEBPACK FOOTER //
// ./client/enum/idSituacaoTarefa.js